import React, { createContext, useState, useEffect } from "react";
import api from "../api";

export const AuthContext = createContext({
  currentUser: null,
  setCurrentUser: () => {},
  logout: () => {},
  loading: true,
});

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount, check for partner token or fetch session user
  useEffect(() => {
    console.log("[AUTHCONTEXT] Initializing - checking for stored auth...");
    
    // Check for partner token first
    const partnerToken = localStorage.getItem("partnerToken");
    const partnerUser = localStorage.getItem("partnerUser");

    console.log("[AUTHCONTEXT] Partner token exists:", !!partnerToken);
    console.log("[AUTHCONTEXT] Partner user exists:", !!partnerUser);

    if (partnerToken && partnerUser) {
      try {
        const user = JSON.parse(partnerUser);
        console.log("[AUTHCONTEXT] Parsed partner user:", user);
        
        // Set token in API headers
        api.defaults.headers.common["Authorization"] = `Bearer ${partnerToken}`;
        console.log("[AUTHCONTEXT] Set Authorization header");
        
        setCurrentUser(user);
        setLoading(false);
        console.log("[AUTHCONTEXT] Partner user restored successfully - loading complete");
      } catch (error) {
        console.error("[AUTHCONTEXT] Failed to parse partner user:", error);
        localStorage.removeItem("partnerToken");
        localStorage.removeItem("partnerUser");
        // Fall back to session-based auth
        fetchSessionUser();
      }
    } else {
      // Try session-based auth (Google OAuth)
      console.log("[AUTHCONTEXT] No partner auth found, trying session-based auth...");
      fetchSessionUser();
    }
  }, []);

  const fetchSessionUser = () => {
    console.log("[AUTHCONTEXT] Fetching session user...");
    api.get("/auth/current-user")
      .then((res) => {
        console.log("[AUTHCONTEXT] Session user fetched:", res.data);
        setCurrentUser(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("[AUTHCONTEXT] Failed to fetch current user:", err);
        setLoading(false);
        console.log("[AUTHCONTEXT] Loading complete - no user");
      });
  };

  // Update the logout function to handle both auth types
  const logout = () => {
    const partnerToken = localStorage.getItem("partnerToken");

    if (partnerToken) {
      // Partner logout
      localStorage.removeItem("partnerToken");
      localStorage.removeItem("partnerUser");
      delete api.defaults.headers.common["Authorization"];
      setCurrentUser(null);
      window.location.href = "/login";
    } else {
      // Session-based logout (Google OAuth)
      api.get("/auth/logout")
        .then(() => {
          setCurrentUser(null);
        })
        .catch((err) => {
          console.error("Logout failed:", err);
        });
    }
  };

  console.log("[AUTHCONTEXT] Rendering - loading:", loading, "currentUser:", currentUser?.username || currentUser?.email || "null");

  return (
    <AuthContext.Provider value={{ currentUser, setCurrentUser, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
